module.exports = __webpack_public_path__ + "static/media/image-regular-games.bfd347d4.jpg";